import React, { useState } from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import { useMediaQuery } from "react-responsive"; // Import for media query handling

const Location = ({ heading, locations }) => {
	// Split the locations into two halves
	const leftLocations = locations.slice(0, 4);
	const rightLocations = locations.slice(4);

	// State to manage active map link and active location
	const [mapLink, setMapLink] = useState(locations[0]?.url); // Default to the first location URL
	const [activeLocation, setActiveLocation] = useState(0); // Default active location index
	const [showAllLocations, setShowAllLocations] = useState(false); // State to toggle showing all locations

	// Check if the screen is small or smaller
	const isSmallScreen = useMediaQuery({ query: "(max-width: 767px)" });

	// Handle changing the map link and active location
	const handleViewInMap = (url, index) => {
		setMapLink(url);
		setActiveLocation(index);
	};

	return (
		<section id="locations" className="py-5 py-lg-7">
			<Container>
				{/* Heading */}
				<Row className="mb-5">
					<Col>
						<h2 className="display-5" style={{ color: "#562A79" }}>
							{heading}
						</h2>
					</Col>
				</Row>

				{/* Locations and Map */}
				<Row className="h-100 g-0 g-md-4 g-xl-5 justify-content-between">
					{/* Left Column Locations */}
					<Col md={6} lg={3} className="">
						{leftLocations.map((location, index) => (
							<div
								key={index}
								className="pb-3"
								// style={{
								// 	borderLeft:
								// 		activeLocation === index
								// 			? "2px solid #562A79"
								// 			: "2px solid transparent",
								// 	paddingLeft: "12px",
								// }}
							>
								<h5 className="text-primary fs-4">{location.heading}</h5>
								<p className="my-2">{location.address}</p>
								<button
									className="purple-link outfit-bold border-0 bg-transparent p-0 text-decoration-underline"
									onClick={() => handleViewInMap(location.url, index)}
									style={{ cursor: "pointer", color: "#562A79" }}
								>
									View in map
								</button>
							</div>
						))}
					</Col>

					{/* Google Map */}
					<Col
						style={{ minHeight: "100%" }}
						lg={6}
						className="d-none d-lg-block"
					>
						<div
							style={{
								width: "100%",
								height: "100%",
								borderRadius: "12px",
								overflow: "hidden",
							}}
						>
							<iframe
								title="Google Map"
								src={mapLink}
								width="100%"
								height="100%"
								style={{ border: 0 }}
								allowFullScreen=""
								loading="lazy"
								referrerPolicy="no-referrer-when-downgrade"
							></iframe>
						</div>
					</Col>

					{/* Right Column Locations */}
					<Col md={6} lg={3} className="">
						{rightLocations
							.slice(
								0,
								isSmallScreen && !showAllLocations ? 0 : rightLocations.length
							)
							.map((location, index) => (
								<div
									key={index + 4}
									className="pb-3 ps-md-3"
									style={{
										borderLeft:
											activeLocation === index + 4
												? "2px solid #562A79"
												: "2px solid transparent",
									}}
								>
									<h5 className="text-primary fs-4">{location.heading}</h5>
									<p className="my-2">{location.address}</p>
									<button
										className="purple-link outfit-bold border-0 bg-transparent p-0 text-decoration-underline"
										onClick={() => handleViewInMap(location.url, index + 4)}
										style={{ cursor: "pointer", color: "#562A79" }}
									>
										View in map
									</button>
								</div>
							))}

						{/* View All Button for Small Screens */}
						{isSmallScreen &&
							!showAllLocations &&
							rightLocations.length > 0 && (
								<div className="text-center mt-4">
									<Button
										variant="outline-primary"
										onClick={() => setShowAllLocations(true)}
										className=" w-100 py-2 px-4"
										style={{ borderRadius: "0px" }}
									>
										View All
									</Button>
								</div>
							)}
					</Col>

					{/* Map for Mobile */}
					<Col
						style={{ minHeight: "100%" }}
						xs={12}
						className="mb-4 mt-4  d-lg-none"
					>
						<div
							style={{
								width: "100%",
								height: "400px",
								borderRadius: "12px",
								overflow: "hidden",
							}}
						>
							<iframe
								title="Google Map"
								src={mapLink}
								width="100%"
								height="100%"
								style={{ border: 0 }}
								allowFullScreen=""
								loading="lazy"
								referrerPolicy="no-referrer-when-downgrade"
							></iframe>
						</div>
					</Col>
				</Row>
			</Container>
		</section>
	);
};

export default Location;
